import { render, staticRenderFns } from "./basebankaccount-form.vue?vue&type=template&id=37cd0cb6&scoped=true&"
import script from "./basebankaccount-form.vue?vue&type=script&lang=js&"
export * from "./basebankaccount-form.vue?vue&type=script&lang=js&"
import style0 from "./basebankaccount-form.vue?vue&type=style&index=0&id=37cd0cb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cd0cb6",
  null
  
)

export default component.exports